import { inject, Injectable, signal } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";

export interface MaintenanceStatus {
  maintenance_mode: boolean;
}

@Injectable({
  providedIn: "root",
})
export class MaintenanceService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = "/api/v1/events/maintenance-status/";

  maintenanceMode = signal<boolean>(false);

  async checkStatus(): Promise<boolean> {
    try {
      const status = await firstValueFrom(this.http.get<MaintenanceStatus>(this.apiUrl));
      this.maintenanceMode.set(status.maintenance_mode);
      return status.maintenance_mode;
    } catch (error) {
      console.error("Error checking maintenance status", error);
      return false;
    }
  }

  async toggleMaintenanceMode(enabled: boolean): Promise<boolean> {
    try {
      const status = await firstValueFrom(
        this.http.post<MaintenanceStatus>(this.apiUrl, { maintenance_mode: enabled })
      );
      this.maintenanceMode.set(status.maintenance_mode);
      return status.maintenance_mode;
    } catch (error) {
      console.error("Error toggling maintenance mode", error);
      throw error;
    }
  }
}
